/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ReactComponent as DeleteIco } from '../../../assets/icons/red-trash.svg'
import { togglePopup } from '../../../Redux/popups/popupSlice'

export default function TableBody({ entry, handleGoToPtFile }) {
  const { t } = useTranslation()
  const { appointments } = entry
  const dispatch = useDispatch()
  const [showAppointmentsModal, setShowAppointmentsModal] = useState(false)
  const [selectedDateAppointments, setSelectedDateAppointments] = useState([])

  // Function to group appointments by date
  const groupAppointmentsByDate = (appointments) => {
    if (!appointments || !Array.isArray(appointments)) return {}
    
    return appointments.reduce((grouped, appointment) => {
      const date = appointment.date
      if (!grouped[date]) {
        grouped[date] = []
      }
      grouped[date].push(appointment)
      return grouped
    }, {})
  }

  // Function to handle clicking on a grouped appointment
  const handleGroupedAppointmentClick = (date, appointmentsForDate) => {
    setSelectedDateAppointments(appointmentsForDate)
    setShowAppointmentsModal(true)
  }
  
  const handleDelete = () => {
    dispatch(
      togglePopup({
        pointer: 4,
        data: {
          deleteData: true,
          id: entry.id,
          full_name: entry.full_name
        }
      })
    )
  }
  
  return (
    <>
    <tr key={entry.id} className={styles.table_tr}>
      <td className={styles.table_td} style={{ textAlign: 'start' }} data-label='Name'>
        {entry.full_name || 'Anonymous'}
      </td>
      <td className={styles.table_td} data-label='Operation'>
        <div className={styles.assigned_op_container}>
          {appointments?.length > 0 ? (
            Object.entries(groupAppointmentsByDate(appointments))
              .sort((a, b) => new Date(a[0]) - new Date(b[0]))
              .map(([date, appointmentsForDate]) => {
                if (appointmentsForDate.length === 1) {
                  // Single appointment display
                  const apt = appointmentsForDate[0]
                  return (
                    <span key={apt.id} className={styles.assigned_op}>
                      {apt.name || apt.operation_name}
                    </span>
                  )
                } else {
                  // Multiple appointments display
                  return (
                    <div 
                      key={date} 
                      className={`${styles.assigned_op} ${styles.grouped_appointment}`}
                      onClick={() => handleGroupedAppointmentClick(date, appointmentsForDate)}
                      title={`${appointmentsForDate.length} ${t('appointments')} - ${new Date(date).toLocaleDateString('en-GB')}`}
                    >
                      <span className={styles.appointment_count}>
                        {appointmentsForDate.length}
                      </span>
                      <span className={styles.appointment_date}>
                        {new Date(date).toLocaleDateString('en-GB', { 
                          day: '2-digit', 
                          month: '2-digit' 
                        })}
                      </span>
                    </div>
                  )
                }
              })
          ) : (
            <span className={styles.unassigned_op}>{t('no_op_assigned')}</span>
          )}
        </div>
      </td>
      <td className={styles.table_td} data-label='Appointments'>
        {entry?.appointments?.length}
      </td>
      <td className={styles.table_td} data-label='File'>
        <div className={styles.action_buttons}>
          <button onClick={() => handleGoToPtFile(entry)} className={`${styles.cert_btn}`}>
            {t('view_file')}
          </button>
          <button onClick={handleDelete} className={styles.delete_btn} title={t('delete_patient')}>
            <DeleteIco className={styles.delete_icon} />
          </button>
        </div>
      </td>
    </tr>
    
    {/* Appointments Modal - Fixed Position Overlay */}
    {showAppointmentsModal && (
      <div className={styles.appointments_modal_overlay}>
        <div className={styles.appointments_modal}>
          <div className={styles.modal_header}>
            <h3>
              {t('appointments_for')} {selectedDateAppointments[0]?.date ? new Date(selectedDateAppointments[0].date).toLocaleDateString('en-GB') : ''}
            </h3>
            <button 
              className={styles.close_modal_btn}
              onClick={() => setShowAppointmentsModal(false)}
            >
              ✖
            </button>
          </div>
          <div className={styles.modal_content}>
            <div className={styles.appointments_list_modal}>
              {selectedDateAppointments.map((appointment) => (
                <div
                  key={appointment.id}
                  className={styles.modal_appointment_item}
                >
                  <div className={styles.modal_appointment_header}>
                    <span className={styles.modal_appointment_name}>
                      {appointment.name || appointment.operation_name || t('no_operation')}
                    </span>
                    <div className={styles.modal_appointment_time}>
                      <span style={{ color: '#2196f3', fontSize: '0.9em' }} title="Time">⏰</span>
                      <span style={{ fontWeight: 600, color: '#2196f3', marginLeft: 4 }}>
                        {appointment.fromStr || t('no_time')}
                      </span>
                    </div>
                  </div>
                  {(appointment.feedback || appointment.examination || appointment.therapy) && (
                    <div className={styles.modal_appointment_details}>
                      {appointment.feedback && (
                        <div className={styles.modal_detail_item}>
                          <span className={styles.detail_label}>{t('feedback')}:</span>
                          <span className={styles.detail_value}>{appointment.feedback}</span>
                        </div>
                      )}
                      {appointment.examination && (
                        <div className={styles.modal_detail_item}>
                          <span className={styles.detail_label}>{t('examination')}:</span>
                          <span className={styles.detail_value}>{appointment.examination}</span>
                        </div>
                      )}
                      {appointment.therapy && (
                        <div className={styles.modal_detail_item}>
                          <span className={styles.detail_label}>{t('therapy')}:</span>
                          <span className={styles.detail_value}>{appointment.therapy}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )}
  </>
  )
}
